
import { GridColumn, GridItem, GridRow } from "commons/ui/Grid";

import ExtensionsProporsionInfo from "components/subComponents/ExtensionsProporsionInfo";
import AttachmentPicker from "components/ui/AttachmentPicker";
import TitleFunctionsTopBlock from "components/ui/TitleFunctionsTopBlock";

import useCheckSectionErrors from "hooks/form/blocks/useCheckSectionErrors";
import useSectionThreeImagesVertical from "hooks/form/blocks/useSectionThreeImagesVertical";
import useTitleFunctionsTopBlock from "hooks/useTitleFunctionsTopBlock";

import { DesktopOrMobile } from "types/enums";

function SectionThreeImagesVerticalForm() {
    const { buttonDelete, setLeftImage, setRightImage, setTextureImage, formHook } =
        useSectionThreeImagesVertical();

    useCheckSectionErrors({ formHook });

    const { checkErrorVisibility, form } = formHook;

    const titleFunctionsTopBlockHook = useTitleFunctionsTopBlock({
        buttonDelete: buttonDelete,
    });

    return (
        <>
            <TitleFunctionsTopBlock titleFunctionsTopBlockHook={titleFunctionsTopBlockHook} />

            {titleFunctionsTopBlockHook.closedBlock && (
                <GridColumn>
                    <ExtensionsProporsionInfo
                        desktopText={"1000x1500px oppure 1000x1000px (max 400KB)"}
                        mobileText={"667x1000px oppure 667x667px (max 250KB)"}
                        proportion={"quadrata o verticale"}
                    />

                    <GridItem className={"col-xs-12-12"}>
                        <GridRow>
                            <div className={"col-xxl-12-6 col-xl-12-12 col-xs-12-12"}>
                                <GridRow>
                                    <GridItem>
                                        <h3>Immagine a sinistra</h3>
                                    </GridItem>
                                </GridRow>

                                <GridRow>
                                    <GridItem className={"col-xs-24-12"}>
                                        <AttachmentPicker
                                            buttonLabel={"Foto Desktop"}
                                            setFile={(file) =>
                                                setLeftImage(file, DesktopOrMobile.desktop)
                                            }
                                            file={form.left_img.desktop}
                                            accept={".png,.jpg,.jpeg"}
                                            errors={checkErrorVisibility("left_img.desktop")}
                                        />
                                    </GridItem>

                                    <GridItem className={"col-xs-24-12"}>
                                        <AttachmentPicker
                                            buttonLabel={"Foto Mobile"}
                                            setFile={(file) =>
                                                setLeftImage(file, DesktopOrMobile.mobile)
                                            }
                                            file={form.left_img.mobile}
                                            accept={".png,.jpg,.jpeg"}
                                            errors={checkErrorVisibility("left_img.mobile")}
                                        />
                                    </GridItem>
                                </GridRow>
                            </div>

                            <div className={"col-xxl-12-6 col-xl-12-12 col-xs-12-12"}>
                                <GridRow>
                                    <GridItem>
                                        <h3>Immagine al centro</h3>
                                    </GridItem>
                                </GridRow>

                                <GridRow>
                                    <GridItem className={"col-xs-24-12"}>
                                        <AttachmentPicker
                                            buttonLabel={"Foto Desktop"}
                                            setFile={(file) =>
                                                setTextureImage(file, DesktopOrMobile.desktop)
                                            }
                                            file={form.center_img.desktop}
                                            accept={".png,.jpg,.jpeg"}
                                            errors={checkErrorVisibility("center_img.desktop")}
                                        />
                                    </GridItem>

                                    <GridItem className={"col-xs-24-12"}>
                                        <AttachmentPicker
                                            buttonLabel={"Foto Mobile"}
                                            setFile={(file) =>
                                                setTextureImage(file, DesktopOrMobile.mobile)
                                            }
                                            file={form.center_img.mobile}
                                            accept={".png,.jpg,.jpeg"}
                                            errors={checkErrorVisibility("center_img.mobile")}
                                        />
                                    </GridItem>
                                </GridRow>
                            </div>
                        </GridRow>
                    </GridItem>

                    <GridRow>
                        <div className={"col-xs-12-12"}>
                            <GridRow>
                                <GridItem>
                                    <h3>Immagine a destra</h3>
                                </GridItem>
                            </GridRow>

                            <GridRow>
                                <GridItem className={"col-xxl-12-3 col-xl-12-6 col-xs-12-6"}>
                                    <AttachmentPicker
                                        buttonLabel={"Foto Desktop"}
                                        setFile={(file) =>
                                            setRightImage(file, DesktopOrMobile.desktop)
                                        }
                                        file={form.right_img.desktop}
                                        accept={".png,.jpg,.jpeg"}
                                        errors={checkErrorVisibility("right_img.desktop")}
                                    />
                                </GridItem>

                                <GridItem className={"col-xxl-12-3 col-xl-12-6 col-xs-12-6"}>
                                    <AttachmentPicker
                                        buttonLabel={"Foto Mobile"}
                                        setFile={(file) =>
                                            setRightImage(file, DesktopOrMobile.mobile)
                                        }
                                        file={form.right_img.mobile}
                                        accept={".png,.jpg,.jpeg"}
                                        errors={checkErrorVisibility("right_img.mobile")}
                                    />
                                </GridItem>
                            </GridRow>
                        </div>
                    </GridRow>
                </GridColumn>
            )}
        </>
    );
}

export default SectionThreeImagesVerticalForm;
